export const optionStyles = {
  // Custom hover styling for each menu item
  "&:hover": {
    backgroundColor: "var(--tvet-secondary, #e1f0f5) !important",
    color: "var(--tvet-secondary-foreground, #006d70) !important",
  },
  "&.Mui-selected": {
    backgroundColor: "var(--tvet-primary, #2a9699) !important",
    color: "var(--tvet-primary-foreground, #ffffff) !important",
    "&:hover": {
      backgroundColor: "var(--tvet-primary-hover, #248a8c) !important",
      color: "var(--tvet-primary-foreground, #ffffff) !important",
    },
  },
};

export const checkboxStyles = {
  color: "#d1d5db",
  "&.Mui-checked": {
    color: "var(--tvet-primary, #2a9699)",
  },
  "& .MuiSvgIcon-root": {
    fontSize: 20,
  },
};

export const listItemTextStyles = {
  "& .MuiTypography-root": {
    fontSize: "14px",
    color: "#000000",
  },
}; 